import { HomeMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenu";

export { HomeMenu };
